import React from 'react';
import { AppBar, Box, Toolbar } from '@mui/material';
import LayoutUserAccount, {
  type LayoutUserAccountProps,
} from './LayoutUserAccount';

export interface LayoutAppBarProps {
  logoHeight: number;
  userAccount: LayoutUserAccountProps;
  startAdornment?: React.ReactNode;
}

const LayoutAppBar: React.FC<LayoutAppBarProps> = ({
  logoHeight,
  userAccount,
  startAdornment,
}) => (
  <AppBar
    position="sticky"
    elevation={0}
    sx={{
      bgcolor: 'background.default',
      color: 'text.primary',
      borderRadius: 0,
      boxShadow: 'none',
      border: 'none',
      zIndex: 1100,
    }}
  >
    <Toolbar sx={{ minHeight: logoHeight, px: 3 }}>
      <Box display="flex" alignItems="center" gap={2} flex={1}>
        {startAdornment}
      </Box>

      <LayoutUserAccount {...userAccount} />
    </Toolbar>
  </AppBar>
);

export default LayoutAppBar;
